/**
 * Campaign name constants
 * Tập trung tất cả campaign names để tránh typo và dễ maintain
 */

export const CAMPAIGN_NAMES = {
  /**
   * Campaign giảm giá mua nhiều giảm nhiều
   * Khi mua nhiều sản phẩm sẽ được giảm giá theo phần trăm
   */
  BUY_MORE_SAVE_MORE: 'buy_more_save_more',

  /**
   * Campaign đồ thu đông giảm 10%
   * Campaign đặc biệt cho sản phẩm đồ thu đông
   */
  DO_THU_DONG_2025: 'do_thu_dong_2025',

  /**
   * Campaign mua 1 tặng 1 quà tự chọn
   * Mua 1 sản phẩm chính từ trang buy-1-get-1-in-gift-shop và được tặng 1 quà tự chọn
   */
  BUY_1_GET_1_IN_GIFT_SHOP: 'buy_1_get_1_in_gift_shop',

  /**
   * Campaign mua 1 tặng 1 giá trị tương đương
   * Mua 1 sản phẩm và được tặng sản phẩm dưới giá max_eligible_price_for_gift
   */
  BUY_1_GET_1_VALUE_MATCH: 'buy_1_get_1_value_match',

  /**
   * Campaign double day
   * Campaign đặc biệt trong ngày double day
   */
  DOUBLE_DAY: 'double_day',

  /**
   * Campaign 20/10
   * Campaign đặc biệt ngày 20/10
   */
  CAMP_20_10: 'camp_20_10',
} as const

/**
 * Type-safe campaign name type
 * Sử dụng để đảm bảo chỉ sử dụng campaign names hợp lệ
 */
export type CampaignName = (typeof CAMPAIGN_NAMES)[keyof typeof CAMPAIGN_NAMES]

